import { render, staticRenderFns } from "./UserAgent.vue?vue&type=template&id=1855fa4e"
import script from "./UserAgent.vue?vue&type=script&lang=js"
export * from "./UserAgent.vue?vue&type=script&lang=js"
import style0 from "./UserAgent.vue?vue&type=style&index=0&id=1855fa4e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports